import { createFocusTrap } from 'focus-trap'

export const body = document.querySelector('body')
export const headerLogo = document.querySelector('.js-header-logo')
export const header = document.getElementById('theme-header')
export const overlay = document.getElementById('theme-overlay')
export const hamburgerButton = document.getElementById('js-hamburger-button')
export const menuPrimary = document.getElementById('js-menu-primary')
export const menuParentItems = document.querySelectorAll(
	'.c-menu__link[aria-expanded]'
)
const MQ_MENU = '(min-width: 950px)'
export const mqMenu = window.matchMedia(MQ_MENU)

const MQ_MOBILE = '(max-width: 600px) and (orientation: portrait)'
export const mqMobile = window.matchMedia(MQ_MOBILE)

const MQ_PROJECT = '(min-width: 1000px)'
export const mqProject = window.matchMedia(MQ_PROJECT)

const MQ_COLUMNS = '(min-width: 900px)'
export const mqColumns = window.matchMedia(MQ_COLUMNS)

export const themeButtons = document.querySelectorAll(
	'#js-theme-switcher .js-theme-option'
)
export const popupToggles = document.querySelectorAll('.js-popup-toggle')
export const popups = document.querySelectorAll('.js-popup')
export const focusTrapMenu = createFocusTrap('#js-navigation-primary')
export const focusTrapContactMenu = createFocusTrap('#js-contact-menu')
export const fullBleedEls = document.querySelectorAll('.u-full-bleed')
export const projectPanels = document.querySelectorAll('.js-panel')
export const projectTabs = document.querySelectorAll('.js-tab')
export const tabWrapper = document.getElementById('js-tab-wrapper')
export const stickyEls = document.querySelectorAll('.js-sticky')
export const viewport = document.documentElement
export const heroEl = document.querySelector('.js-hero')
export const cards = document.querySelectorAll('.js-card')
export const videos = document.querySelectorAll('.js-video-tag')
export const projectTitle = document.getElementById('js-project-title')
export const projectData = document.getElementById('js-project-data')
export const projectCards = document.querySelectorAll('.js-project-card')
export const projectFilters = document.querySelectorAll(
	'.js-project-filter-button'
)
export const projectsLayout = document.querySelectorAll(
	'.js-projects-layout-button'
)
export const projectNavigationToggles = document.querySelectorAll(
	'.js-project-navigation-toggle'
)
export const projectNavigationProgramaMenu = document.getElementById(
	'js-project-navigation-menu-programa'
)
export const projectNavigationLayoutMenu = document.getElementById(
	'js-project-navigation-menu-layout'
)
export const toggleContactDialogEls =
	document.querySelectorAll('.js-contact-toggle')
export const newsletterDialog = document.getElementById('js-contact-dialog')
export const footerContactButton = document.querySelector(
	'.js-footer-contact-button'
)
export const footerSocialWrapper = document.querySelector('.c-social-wrapper')
export const floatingMenuToggle = document.getElementById(
	'js-floating-menu-toggle'
)
export const floatingMenu = document.getElementById('js-floating-menu')
export const homeContactButtons = document.querySelectorAll('.js-menu-contact')
export const homeContactMenu = document.getElementById('js-contact-menu')
export const sortTableButtons = document.querySelectorAll(
	'.js-table-sort-button'
)
export const mediaTextBlocks = document.querySelectorAll('.wp-block-media-text')
